import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "table table-tenant" }
const _hoisted_6 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", null, "Party ID", -1)
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = { class: "text-center" }

import { ref, onMounted, watch, nextTick } from "vue";
import { useI18n } from "vue-i18n";
import UserService from "../services/UserService";
import TenantGlobalService from "@/projects/tenant/services/TenantGlobalService";
import notification from "@/core/plugins/notification";
import UserDetails from "../../../components/UserDetails.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'UserDocumentIndex',
  setup(__props) {

const { t } = useI18n();
const activeTab = ref(0);
const isLoading = ref(false);
const users = ref(Array<any>());
const userShow = ref<InstanceType<typeof UserDetails>>();
const tabsData = [
  {
    index: 0,
    label: "No Documents",
    tag: "NoDocument",
  },
  {
    index: 1,
    label: "Review Uploaded Documents",
    tag: "DocumentUploaded",
  },
];

const showDetail = async (partyId: number) => {
  userShow.value?.show(partyId, "documents");
};

const criteria = ref<any>({
  page: 1,
  size: 20,
  tags: ["NoDocument"],
});

const handleClick = async () => {
  isLoading.value = true;
  await nextTick();
  var tag = tabsData[activeTab.value].tag;
  criteria.value.tags = [tag];
  await fetchData(1);
};

const fetchData = async (_page: number) => {
  isLoading.value = true;
  criteria.value.page = _page;
  try {
    const res = await UserService.getUsers(criteria.value);
    criteria.value = res.criteria;
    users.value = res.data;
    users.value.forEach((user) => {
      user.isLoading = false;
    });
  } catch (e) {
    console.error(e);
  }
  isLoading.value = false;
};

const removeTag = async (item: any) => {
  item.isLoading = true;
  try {
    const res = await TenantGlobalService.updateTagsById({
      type: "party",
      rowId: item.partyId,
      name: tabsData[activeTab.value].tag,
      enabled: false,
    });
    users.value = users.value.filter((user) => user.partyId !== item.partyId);
    notification.success();
  } catch (e) {
    console.error(e);
  } finally {
    item.isLoading = false;
  }
};

const getUserName = (item: any) => {
  if (!item.nativeName || item.nativeName === "" || item.nativeName === " ") {
    if (
      !item.displayName ||
      item.displayName === "" ||
      item.displayName === " "
    ) {
      if (
        !item.firstName ||
        !item.lastName ||
        item.firstName === "" ||
        item.lastName === "" ||
        item.firstName === " " ||
        item.lastName === " "
      ) {
        return "No Name";
      } else {
        return item.firstName + " " + item.lastName;
      }
    } else {
      return item.displayName;
    }
  } else {
    return item.nativeName;
  }
};

onMounted(async () => {
  await fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_UserInfo = _resolveComponent("UserInfo")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_TableFooter = _resolveComponent("TableFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_tabs, {
      onTabClick: handleClick,
      modelValue: activeTab.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
      type: "card"
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabsData, (tab, index) => {
          return _createVNode(_component_el_tab_pane, {
            key: index,
            label: tab.label,
            name: tab.index,
            disabled: isLoading.value
          }, null, 8, ["label", "name", "disabled"])
        }), 64))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            type: "success",
            plain: "",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (fetchData(1))),
            disabled: isLoading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.refresh")), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.user")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.site")), 1),
              _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t("fields.emailConfirmed")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.phoneNum")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.country")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.language")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.updatedOn")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.action")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                _createVNode(_component_LoadingRing)
              ]))
            : (!isLoading.value && users.value.length === 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: index,
                      class: _normalizeClass([{ 'row-inactive': item.status !== 0 }])
                    }, [
                      _createElementVNode("th", null, _toDisplayString(item.partyId) + " (" + _toDisplayString(item.id) + ") ", 1),
                      _createElementVNode("td", _hoisted_12, [
                        _createVNode(_component_UserInfo, {
                          url: "#",
                          avatar: item.avatar,
                          title: getUserName(item),
                          sub: item.email,
                          name: getUserName(item),
                          user: item,
                          class: "me-2"
                        }, null, 8, ["avatar", "title", "sub", "name", "user"])
                      ]),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t("type.siteType." + item.siteId)), 1),
                      _createElementVNode("td", _hoisted_13, [
                        _createElementVNode("i", {
                          class: "fa-solid fa-circle-check fa-lg",
                          style: _normalizeStyle(item.emailConfirmed ? 'color: #5cb85c' : 'color: #gray')
                        }, null, 4)
                      ]),
                      _createElementVNode("td", null, "+" + _toDisplayString(item.ccc) + " " + _toDisplayString(item.phoneNumber), 1),
                      _createElementVNode("td", null, _toDisplayString(item.countryCode), 1),
                      _createElementVNode("td", null, _toDisplayString(item.language), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_TimeShow, {
                          "date-iso-string": item.updatedOn
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_TimeShow, {
                          "date-iso-string": item.createdOn
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", null, [
                        (activeTab.value == 1)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              onClick: ($event: any) => (showDetail(item.partyId)),
                              type: "primary",
                              plain: ""
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("action.review")), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_el_button, {
                          type: "warning",
                          plain: "",
                          loading: item.isLoading,
                          onClick: ($event: any) => (removeTag(item))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("action.check")), 1)
                          ]),
                          _: 2
                        }, 1032, ["loading", "onClick"])
                      ])
                    ], 2))
                  }), 128))
                ]))
        ]),
        _createVNode(_component_TableFooter, {
          onPageChange: fetchData,
          criteria: criteria.value
        }, null, 8, ["criteria"])
      ])
    ]),
    _createVNode(UserDetails, {
      ref_key: "userShow",
      ref: userShow
    }, null, 512)
  ], 64))
}
}

})